import _Menu from "@mui/material/Menu";
import _MenuItem from "@mui/material/MenuItem";
import _ListItemText from "@mui/material/ListItemText";
import _ListItemIcon from "@mui/material/ListItemIcon";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _MoreHoriz from "@mui/icons-material/MoreHoriz";
import _ButtonBase from "@mui/material/ButtonBase";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import _Avatar from "@mui/material/Avatar";
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import challengeEndIcon from '../assets/images/news/challenge-end.svg';
import challengeStartIcon from '../assets/images/news/challenge-start.svg';
import alertIcon from '../assets/images/news/news-post-alert.svg';
import objectif100Icon from '../assets/images/news/objective-100.svg';
import objectif25Icon from '../assets/images/news/objective-25.svg';
import objectif50Icon from '../assets/images/news/objective-50.svg';
import objectif75Icon from '../assets/images/news/objective-75.svg';
import topRankingIcon from '../assets/images/news/top-ranking.svg';
import { Button, EditIcon, GeogroupAvatar, LikeIcon, LikeOulinedIcon, LinkIcon, PersonIcon, PhotosDialog, RemoveIcon, UserAvatar } from '../components';
import { AppService, GeogroupService } from '../services';
import { RemovePostDialog } from './remove-post-dialog';
export const newsPostsIcons = {
  challengeEnd: challengeEndIcon,
  challengeObjective100: objectif100Icon,
  challengeObjective25: objectif25Icon,
  challengeObjective50: objectif50Icon,
  challengeObjective75: objectif75Icon,
  challengeStart: challengeStartIcon,
  challengeTopRanking: topRankingIcon,
  manual: alertIcon
};
export function NewsPostCard({
  Dialog,
  Link,
  small,
  currentPartner,
  currentUser,
  geogroup,
  userType,
  editPath,
  newsPost,
  onEdit,
  onRemoved
}) {
  const [photosDialogOpen, openPhotosDialog] = useState(false);
  const [showedPhotos, showPhotos] = useState(null);
  const [settingsMenuAnchorEl, setSettingsMenuAnchorEl] = useState(null);
  const [removeDialogOpen, openRemoveDialog] = useState(false);
  const [liking, setLiking] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    transitions
  } = useTheme();
  function handlePhotosDialogOpen() {
    if (!newsPost || !newsPost.photo) return;
    showPhotos([{
      url: `${AppService.environment.backendUrl}${newsPost.photo}`
    }]);
    openPhotosDialog(true);
  }
  function handlePhotosDialogClose() {
    openPhotosDialog(false);
    setTimeout(() => showPhotos(null), transitions.duration.leavingScreen);
  }
  async function handleLike() {
    if (!newsPost) return;
    setLiking(true);
    try {
      if (!newsPost.liked) {
        await GeogroupService.likeNewsPost({
          newsPostId: newsPost.id
        });
        newsPost.liked = true;
        newsPost.likesCount = (newsPost.likesCount || 0) + 1;
      } else {
        await GeogroupService.unlikeNewsPost({
          newsPostId: newsPost.id
        });
        newsPost.liked = false;
        newsPost.likesCount = (newsPost.likesCount || 0) - 1;
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.news.server_error_like'));
    }
    setLiking(false);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    display: "flex",
    gap: 5
  }, /*#__PURE__*/React.createElement(_Box, {
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1.5
  }, newsPost ? newsPost.postedByGroup ? /*#__PURE__*/React.createElement(GeogroupAvatar, {
    geogroup: newsPost.geogroup
  }) : newsPost.creator ? /*#__PURE__*/React.createElement(UserAvatar, {
    user: newsPost.creator
  }) : /*#__PURE__*/React.createElement(_Avatar, {
    sx: ({
      palette
    }) => ({
      bgcolor: palette.primary.light,
      height: 32,
      width: 32
    })
  }, /*#__PURE__*/React.createElement(PersonIcon, {
    fontSize: "small",
    sx: {
      color: '#fff'
    }
  })) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 32,
    variant: "circular",
    width: 32
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 0.5
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    lineHeight: 1,
    variant: "body2"
  }, newsPost ? newsPost.postedByGroup ? newsPost.geogroup?.title || '' : newsPost.creator ? newsPost.creator.username : /*#__PURE__*/React.createElement("i", null, t('commons.news.deleted_user')) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 150
  })), newsPost?.postedByGroup && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    alignSelf: "flex-start",
    bgcolor: "#F3F6FF",
    borderRadius: 4,
    color: "#326ac2",
    display: "flex",
    gap: 0.5,
    paddingX: 1,
    paddingY: 0.5
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    lineHeight: 1,
    variant: "caption"
  }, "Admin"))), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, newsPost ? newsPost.created.format('LL') : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })))), newsPost ? newsPost.photo && /*#__PURE__*/React.createElement(_Box, {
    component: _ButtonBase,
    display: small ? 'block' : {
      xs: 'block',
      md: 'none'
    },
    flexShrink: 0,
    onClick: handlePhotosDialogOpen,
    width: 200
  }, /*#__PURE__*/React.createElement("img", {
    src: `${AppService.environment.backendUrl}${newsPost.photo}`,
    width: 200
  })) : /*#__PURE__*/React.createElement(_Box, {
    display: small ? 'block' : {
      xs: 'block',
      md: 'none'
    },
    flexShrink: 0,
    width: 200
  }, /*#__PURE__*/React.createElement(_Skeleton, {
    height: 150,
    variant: "rounded",
    width: 200
  })), /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(_Typography, {
    component: "div",
    sx: {
      '> div > p': {
        margin: 0
      }
    },
    variant: "body2"
  }, newsPost ? /*#__PURE__*/React.createElement(_Box, {
    dangerouslySetInnerHTML: {
      __html: newsPost.text
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "100%"
  }), /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: "90%"
  })))), newsPost?.link && /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    component: "a",
    href: newsPost.link?.url,
    rel: "noreferrer",
    size: "small",
    startIcon: /*#__PURE__*/React.createElement(LinkIcon, null),
    target: "_blank",
    variant: "text"
  }, newsPost.link?.label || t('commons.news.link')))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, newsPost && currentUser !== undefined ? currentUser && /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    disabled: liking,
    onClick: handleLike,
    size: "small",
    startIcon: newsPost.liked ? /*#__PURE__*/React.createElement(LikeIcon, null) : /*#__PURE__*/React.createElement(LikeOulinedIcon, null)
  }, newsPost.likesCount || 0) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 30,
    variant: "rounded",
    width: 64
  }), newsPost && (userType === 'admin' || currentUser && newsPost.creator && newsPost.creator.id === currentUser.id) && /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "right",
    title: t('commons.settings')
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_IconButton, {
    disabled: !newsPost,
    onClick: ({
      currentTarget
    }) => setSettingsMenuAnchorEl(currentTarget),
    size: "small"
  }, /*#__PURE__*/React.createElement(_MoreHoriz, {
    color: "action",
    fontSize: "small"
  }))))), newsPost && /*#__PURE__*/React.createElement(_Menu, {
    anchorEl: settingsMenuAnchorEl,
    onClose: () => setSettingsMenuAnchorEl(null),
    open: Boolean(settingsMenuAnchorEl),
    slotProps: {
      root: {
        sx: {
          '.MuiBackdrop-root': {
            bgcolor: 'initial'
          }
        }
      },
      paper: {
        sx: {
          borderRadius: 2
        }
      }
    }
  }, newsPost.type === 'manual' && (userType === 'admin' && newsPost.postedByGroup || currentUser && newsPost.creator && newsPost.creator.id === currentUser.id) && /*#__PURE__*/React.createElement(React.Fragment, null, Link && !onEdit && editPath && /*#__PURE__*/React.createElement(_MenuItem, {
    dense: true,
    component: Link,
    to: editPath
  }, /*#__PURE__*/React.createElement(_ListItemIcon, null, /*#__PURE__*/React.createElement(EditIcon, null)), /*#__PURE__*/React.createElement(_ListItemText, {
    primary: t('commons.actions.edit')
  })), onEdit && /*#__PURE__*/React.createElement(_MenuItem, {
    dense: true,
    onClick: () => {
      setSettingsMenuAnchorEl(null);
      onEdit();
    }
  }, /*#__PURE__*/React.createElement(_ListItemIcon, null, /*#__PURE__*/React.createElement(EditIcon, null)), /*#__PURE__*/React.createElement(_ListItemText, {
    primary: t('commons.actions.edit')
  }))), /*#__PURE__*/React.createElement(_MenuItem, {
    dense: true,
    onClick: () => {
      setSettingsMenuAnchorEl(null);
      openRemoveDialog(true);
    }
  }, /*#__PURE__*/React.createElement(_ListItemIcon, null, /*#__PURE__*/React.createElement(RemoveIcon, {
    color: "error"
  })), /*#__PURE__*/React.createElement(_ListItemText, {
    primary: t('commons.actions.remove')
  })))), newsPost ? newsPost.photo && /*#__PURE__*/React.createElement(_Box, {
    component: _ButtonBase,
    display: small ? 'none' : {
      xs: 'none',
      md: 'block'
    },
    flexShrink: 0,
    onClick: handlePhotosDialogOpen,
    width: 200
  }, /*#__PURE__*/React.createElement("img", {
    src: `${AppService.environment.backendUrl}${newsPost.photo}`,
    width: 200
  })) : /*#__PURE__*/React.createElement(_Box, {
    display: small ? 'none' : {
      xs: 'none',
      md: 'block'
    },
    flexShrink: 0,
    width: 200
  }, /*#__PURE__*/React.createElement(_Skeleton, {
    height: 150,
    variant: "rounded",
    width: 200
  }))), /*#__PURE__*/React.createElement(PhotosDialog, {
    onClose: handlePhotosDialogClose,
    open: photosDialogOpen,
    photos: showedPhotos
  }), newsPost && /*#__PURE__*/React.createElement(RemovePostDialog, {
    currentPartner: currentPartner,
    Dialog: Dialog,
    geogroup: geogroup,
    handleClose: removed => {
      openRemoveDialog(false);
      if (removed) onRemoved?.();
    },
    newsPost: newsPost,
    open: removeDialogOpen
  }));
}
export { alertIcon };